import {styled} from "@mui/material/styles";
import {Box, Table, TableCell, TableContainer} from "@mui/material";

/**
 * @deprecated
 */
export const TableRoot = styled('div')(() => ({
  width: '100%',
  backgroundColor: '#fff'
}));

/**
 * @deprecated
 */
export const TableContainerRoot = styled(TableContainer)(({isShadow}: {isShadow?: boolean}) => ({
  '&::-webkit-scrollbar': {
    height: '0.4em',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888'
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
  },
  ...(isShadow && {
    boxShadow: '0px 0px 0px 1px #E0E0E0',
    borderRadius: '0.4em',
  })
}));

/**
 * @deprecated
 */
export const TablePaper = styled(Box)(({theme}) => ({
  width: '100%',
  marginBottom: theme.spacing(2),
}));

/**
 * @deprecated
 */
export const TableMinWidth = styled(Table)(() => ({
  minWidth: 750,
}));

/**
 * @deprecated
 */
export const TableHeadUpperCase = styled(TableCell)(({isUppercase}: {isUppercase?: boolean}) => ({
  ...(isUppercase && {
    textTransform: 'uppercase',
  })
}));
